import React from 'react'

export const dataModal = [
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            Ganadores Edición 2007
          </h1>
          <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-3 tw-mb-4@lg">
            El Jurado Calificador siguiendo las pautas de evaluación
            establecidas en las bases de los concursos, designaron a los
            ganadores, declarando un empate en el segundo puesto del Premio
            Adulto Mayor Emprendedor Prima AFP, así como en el Premio
            Reconocimiento Adulto Mayor Destacado Prima AFP, en el campo
            artístico.
          </p>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Adulto Mayor Emprendedor Prima AFP
        </h2>
        <div className="table-0 w-100 tw-mb-8 tw-mb-10@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-15 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg"></th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Empresa</span>
                </th>
                <th className="w-20 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">1er Puesto</td>
                <td className="tw-py-5 tw-pr-9@lg">Francisco Tam Rivero</td>
                <td className="tw-py-5 tw-pl-9@lg">91</td>
                <td className="tw-py-5 tw-pr-9@lg">Establo San Valentín </td>
                <td className="tw-py-5 tw-pr-9@lg right">Trujillo</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">2do Puesto </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Rafael Del Águila Del Águila
                </td>
                <td className="tw-py-5 tw-pl-9@lg">83</td>
                <td className="tw-py-5 tw-pr-9@lg">SETEMIN Ingenieros</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">2do Puesto </td>
                <td className="tw-py-5 tw-pr-9@lg">Manuel Castrejón Reyes </td>
                <td className="tw-py-5 tw-pl-9@lg">72</td>
                <td className="tw-py-5 tw-pr-9@lg">Nido Magic World </td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor Destacado
        </h2>
        <div className="table-0 w-100 tw-mb-3 tw-mb-4@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Campo</span>
                </th>
                <th className="w-30 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-30 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Empresarial</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Dr. Uriel García Cáceres{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">83</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Social</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Sra. Consuelo Torres Tello{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">89</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Intelectual</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Dr. Benjamín Alhalel Gabay
                </td>
                <td className="tw-py-5 tw-pl-9@lg">85</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Edilberto Mérida Rodríguez{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">80 </td>
                <td className="tw-py-5 tw-pr-9@lg right">Cuzco</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">Jesús Urbano Rojas </td>
                <td className="tw-py-5 tw-pl-9@lg">78</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            Ganadores Edición 2008
          </h1>
          <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-3 tw-mb-4@lg">
            El Jurado Calificador del Premio Adulto Mayor Emprendedor y Premio
            Reconocimiento Adulto Mayor, siguiendo las pautas de evaluación
            establecidas en las bases, designaron a los siguientes ganadores:
          </p>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Adulto Mayor Emprendedor Prima AFP
        </h2>
        <div className="table-0 w-100 tw-mb-8 tw-mb-10@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-15 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg"></th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Empresa</span>
                </th>
                <th className="w-20 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">1er Puesto</td>
                <td className="tw-py-5 tw-pr-9@lg">Wilson Bernal Carranza </td>
                <td className="tw-py-5 tw-pl-9@lg">73</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Asociación De Apicultores De Amazonas Triple "A"{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg right">Bagua</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">2do Puesto </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Carlos Oswaldo Ponce Castro{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">79</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Artesanía Artística Mochica{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg right">Trujillo</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor Destacado
        </h2>
        <div className="table-0 w-100 tw-mb-3 tw-mb-4@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Campo</span>
                </th>
                <th className="w-30 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-30 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Empresarial</td>
                <td className="tw-py-5 tw-pr-9@lg">José Vila Arseda </td>
                <td className="tw-py-5 tw-pl-9@lg">78 </td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Social</td>
                <td className="tw-py-5 tw-pr-9@lg">Grimaneza Wiese Montero </td>
                <td className="tw-py-5 tw-pl-9@lg">75</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Intelectual</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Juan Vicente Ugarte Del Pino{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">85</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">Maximo Damián Huamaní </td>
                <td className="tw-py-5 tw-pl-9@lg">74</td>
                <td className="tw-py-5 tw-pr-9@lg right">Cuzco</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            Ganadores Edición 2009
          </h1>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Adulto Mayor Emprendedor Prima AFP
        </h2>
        <div className="table-0 w-100 tw-mb-8 tw-mb-10@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-15 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg"></th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Empresa</span>
                </th>
                <th className="w-20 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">1er Puesto</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Jaime Rodolfo Jordán Massa{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">76 </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Miniaturas Colecciones Militares E.I.R.L.{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">2do Puesto </td>
                <td className="tw-py-5 tw-pr-9@lg">Antonio Taipe Quispe </td>
                <td className="tw-py-5 tw-pl-9@lg">67</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Empresa Artesanal El Ayllu Sumaq Ruracc S.R.L{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg right">Huancavelica</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor Destacado
        </h2>
        <div className="table-0 w-100 tw-mb-3 tw-mb-4@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Campo</span>
                </th>
                <th className="w-30 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-30 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Empresarial</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Máximo San Román Cáceres{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">63</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Empresarial</td>
                <td className="tw-py-5 tw-pr-9@lg">José Mallqui Peña </td>
                <td className="tw-py-5 tw-pl-9@lg">79</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Social</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Antonio Guillermo Silva Castellano{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">78</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Intelectual</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Dante Antonio Peñaloza Ramella{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">87</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Enrique Victoria Fernández{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">83</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            Ganadores Edición 2010
          </h1>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Adulto Mayor Emprendedor Prima AFP
        </h2>
        <div className="table-0 w-100 tw-mb-8 tw-mb-10@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-15 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg"></th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Empresa</span>
                </th>
                <th className="w-20 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">1er Puesto</td>
                <td className="tw-py-5 tw-pr-9@lg">José Parodi </td>
                <td className="tw-py-5 tw-pl-9@lg">81 </td>
                <td className="tw-py-5 tw-pr-9@lg">Helados Ovni </td>
                <td className="tw-py-5 tw-pr-9@lg right">Cañete</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">2do Puesto </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Georgina Mac Hay Villasante{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">77</td>
                <td className="tw-py-5 tw-pr-9@lg">Drugstore Video S.R.L. </td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor Destacado
        </h2>
        <div className="table-0 w-100 tw-mb-3 tw-mb-4@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Campo</span>
                </th>
                <th className="w-30 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-30 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Empresarial</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Wilfredo Gregorio Botto Sifuentes{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">63</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Empresarial</td>
                <td className="tw-py-5 tw-pr-9@lg">Alberto Solis Serrepe </td>
                <td className="tw-py-5 tw-pl-9@lg">79</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Social</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Adriana Eunice Rebaza Flores{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">78</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Intelectual</td>
                <td className="tw-py-5 tw-pr-9@lg">Javier Arias Stella </td>
                <td className="tw-py-5 tw-pl-9@lg">87</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">Oscar Avilés Arcos </td>
                <td className="tw-py-5 tw-pl-9@lg">83</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">Teófilo Araujo Choque </td>
                <td className="tw-py-5 tw-pl-9@lg">68</td>
                <td className="tw-py-5 tw-pr-9@lg right">Ayacucho</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            Ganadores Edición 2011
          </h1>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Adulto Mayor Emprendedor Prima AFP
        </h2>
        <div className="table-0 w-100 tw-mb-8 tw-mb-10@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-15 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg"></th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Empresa</span>
                </th>
                <th className="w-20 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">1er Puesto</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  José Manuel Capuñay Preciado{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">76</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  R. Y J. Global Trading S.C.R.L.{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">2do Puesto </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Alejandro Marcacuzco Chinchay{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">62</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Construcciones Equipos Eléctricos Y Servicio S.R.L.{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor Destacado
        </h2>
        <div className="table-0 w-100 tw-mb-3 tw-mb-4@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Campo</span>
                </th>
                <th className="w-30 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-30 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Empresarial</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Lidia Vega Vda. De Olaechea{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">86</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Social</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  María Julia Venegas Salinas{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">96</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Intelectual</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Alberto Antonio Giesecke Matto{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">93</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">Reynado D´Amore Black </td>
                <td className="tw-py-5 tw-pl-9@lg">88</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">Eduardo Moll Wagner </td>
                <td className="tw-py-5 tw-pl-9@lg">81</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            Ganadores Edición 2012
          </h1>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Adulto Mayor Emprendedor Prima AFP
        </h2>
        <div className="table-0 w-100 tw-mb-8 tw-mb-10@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-15 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg"></th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Empresa</span>
                </th>
                <th className="w-20 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">1er Puesto</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  José García-Calderón Bustamante{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">90</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  La Mansión Del Fundador S.A.{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg right">Arequipa</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">2do Puesto </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Guido Oracio Carabelli Pace{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">68</td>
                <td className="tw-py-5 tw-pr-9@lg">GLUCOM S.A.C. </td>
                <td className="tw-py-5 tw-pr-9@lg right">Trujillo</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor Destacado
        </h2>
        <div className="table-0 w-100 tw-mb-3 tw-mb-4@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Campo</span>
                </th>
                <th className="w-30 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-30 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Empresarial</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Bertilo Malpartida Tello{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">81</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Social</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Teresa De Jesús Pasco Ramírez De Aysanoa{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">83</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Intelectual</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Teodoro Emilio Harmsen Gómez De La Torre{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">94</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">Raúl García Zárate </td>
                <td className="tw-py-5 tw-pl-9@lg">80</td>
                <td className="tw-py-5 tw-pr-9@lg right">Cuzco</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            Ganadores Edición 2013
          </h1>
          <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-3 tw-mb-4@lg">
            El Jurado Calificador del Premio Adulto Mayor Emprendedor y Premio
            Reconocimiento Adulto Mayor, siguiendo las pautas de evaluación
            establecidas en las bases, designaron a los siguientes ganadores:
          </p>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Adulto Mayor Emprendedor Prima AFP
        </h2>
        <div className="table-0 w-100 tw-mb-8 tw-mb-10@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-15 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg"></th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Empresa</span>
                </th>
                <th className="w-20 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">1er Puesto</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Víctor Rafael Haaker Rosas{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">63</td>
                <td className="tw-py-5 tw-pr-9@lg">HAUK S.A.C </td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">2do Puesto </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Pablo Antonio Páez Olcese{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">76</td>
                <td className="tw-py-5 tw-pr-9@lg">LATIN PERÚ S.A.C </td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor Destacado
        </h2>
        <div className="table-0 w-100 tw-mb-3 tw-mb-4@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-25 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Campo</span>
                </th>
                <th className="w-30 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-15 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg">
                  <span className="c-white tw-f-16 tw-f-18@lg">Edad</span>
                </th>
                <th className="w-30 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg right">
                  <span className="c-white tw-f-16 tw-f-18@lg">Lugar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Empresarial</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Alfonso Luis Torres Della Pina{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">68</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Social</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Hna. María Estrella Del Carmen Valcárcel Muñiz{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">91</td>
                <td className="tw-py-5 tw-pr-9@lg right">Ayacucho</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Intelectual</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Área De Literatura: Carlos Germán Belli De La Torre{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">86</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Intelectual</td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Área De Medicina: David Alejandro Tejada De Rivero{' '}
                </td>
                <td className="tw-py-5 tw-pl-9@lg">84 </td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Artístico</td>
                <td className="tw-py-5 tw-pr-9@lg">Sixto Seguil Dorregaray </td>
                <td className="tw-py-5 tw-pl-9@lg">65</td>
                <td className="tw-py-5 tw-pr-9@lg right">Lima</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            Ganadores Edición 2014
          </h1>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Adulto Mayor Emprendedor Prima AFP
        </h2>
        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Artistico:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Alicia Rosa Catalina Maguiña Málaga{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Cantante, Compositora E Investigadora De La Música Peruana En
                  Especial La Música Criolla, Natural De Arequipa. En 1963,
                  Compuso Su Tema Más Importante, Que Le Ha Traído Mayor
                  Cantidad De Satisfacciones: "Indio" Y Que Ha Sido Grabado Por
                  Diferentes Artistas. Trabajó En Radio Nacional Del Perú
                  Conduciendo La Hora De Alicia Maguiña. Tiene Cerca De 30
                  Grabaciones Incluyendo Valses Y Marineras. Reconocimientos:
                  Orden De Sol En Grado De Gran Comendador, Palmas Artísticas
                  Del Ministerio De Educación Del Perú.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Empresarial:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Teodoro Ortiz Tocre </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Gerente General De Industrias Alimenticias Cusco S.A. INCASUR.
                  Empresario Cusqueño Pionero En La Transformación De La Quinua,
                  Kiwicha Y Otros Granos Andinos Para El Mercado Nacional E
                  Internacional. Gracias A Su Visión, INCASUR Es La Empresa
                  Pionera En La Industrialización De La Quinua Y Kiwicha, Siendo
                  La Única Que Procesa E Industrializa A Gran Escala Dichos
                  Cultivos Andinos, Base De Más De 70 Productos Y Marcas
                  Reconocidas Como Kiwigen, Kiwilocos E Incasur, Así Como El
                  Clásico Chocolate En Taza Sol Del Cusco, Los Cuales Se Venden
                  En Todo El País Y También Se Exportan A EE.UU., Bolivia,
                  Chile, Colombia, Argentina, Suiza, Canadá, Centroamérica,
                  Venezuela Y Japón.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Intelectual:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Luis Guillermo Lumbreras Salcedo{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Antropólogo, Arqueólogo Y Educador Peruano, Reconocido Como
                  Uno De Los Arqueólogos Más Brillantes De América Latina Porque
                  Impregnó Una Nueva Perspectiva A La Arqueología Con Valiosos
                  Aportes, No Sólo En El Aspecto Descriptivo Y Analítico, Sino
                  También En El Plano Teórico De La Definición De La Arqueología
                  Peruana. Es El Impulsor De La Llamada Arqueología Social, Que
                  No Se Limita A La Recopilación De Datos, Sino Que Participa
                  Del Desarrollo Y La Integración De La Sociedad. Planteó La
                  Teoría Hologenista Sobre El Origen De La Cultura En El Perú,
                  Que Sostiene Que En Ella Actuaron Tanto Elementos Propios O
                  Autóctonos, Como Foráneos. Ha Publicado 36 Libros De Su
                  Autoría.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo de Servicio Social
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Yolanda Liliana Mayo Ortega{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Fundadora Y Directora General Del Centro Ann Sullivan Del
                  Perú-CASP, Creado En 1979 Y Que Hoy Cuenta Con Más De 430
                  Estudiantes En Sus Programas Educativos, Desde Bebés Hasta
                  Adultos. La Dra. Mayo Y El Equipo CASP En Conjunto Con La Dra.
                  Judith LeBlanc, De La Universidad De Kansas Han Desarrollado
                  El Modelo Del Al Curriculum Funcional/Natural Para Las
                  Familias Y Personas Con Habilidades Diferentes, Modelo Peruano
                  Exitoso Que Hoy Está En Más De 8 Países Y Está Expandiéndose
                  En Nuestro País Gracias A La Educación Virtual.
                </td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Pedro Augusto Angulo Pinto{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Médico Cirujano Ortopédico Fundador Del Hogar Clínica San Juan
                  De Dios Donde Empezó Como Asistente Y Llegó A Ser Director
                  Médico, Hospital En El Que Lleva Más De 50 Años Consecutivos
                  Trabajando Ad Honorem. Fue Profesor De Ortopedia Y
                  Traumatología Por 25 Años En El Pre Y Postgrado La Facultad De
                  Medicina De La Universidad Federico Villarreal -UNFV, Y En La
                  UNMSM Inició La Escuela De Tecnología Médica: Medicina Física
                  Y Rehabilitación. Tiene Varios Artículos En Revistas Y
                  Publicaciones Sobre Su Especialidad. Preside El Patronato
                  Peruano De Rehabilitación, Que Realiza Campañas De Despistaje
                  En AA.HH.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Primer Lugar Campo Emprendedor
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Francisco Contreras Campos{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Médico Oftalmólogo, Gerente General De Oftalmólogos Contreras
                  Soc. Civil De Responsabilidad Limitada, Empresa Que Desde 1987
                  Se Dedica A La Salud Ocular Y Está Conformada Por Un Equipo De
                  Profesionales Especializados En El Cuidado Y Tratamiento De
                  Los Ojos, De Las Diferentes Áreas De La Oftalmología.
                  Oftalmólogos Contreras Contribuye A La Capacitación Y
                  Formación De Los Futuros Médicos Oftalmólogos Y Técnicos
                  Oftálmicos Del País. Ha Publicado Numerosos Artículos En El
                  Campo De La Oftalmología Y En Prevención De Ceguera. Es
                  Fundador Y Presidente De La Asociación Oftalmológica Paracas,
                  Entidad Sin Fines De Lucro Que Realiza Diversas Actividades
                  Educativas Y Campañas Quirúrgico-Asistenciales Tanto En La
                  Periferia De Lima Como En La Provincia De Abancay (Zona Andina
                  Del Perú) Y Otras Zonas Más Deprimidas Del País.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Segundo Lugar Campo Emprendedor
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Benita Cutipa Chura De López{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Directora De Royal Knit S.A.C., Empresa Familiar Fundada Hace
                  Casi 14 Años En La Ciudad Del Cusco Con El Objeto Principal De
                  Elaborar Prendas De Vestir En Alpaca Y Algodón Pima Para
                  Exportación. Trabajan Con Más De 300 Artesanos Y Artesanas De
                  Cusco Y Puno, A Las Cuales Dan Capacitación Permanente. Meta:
                  Lograr Ventas Por 1.5 Millones De Dólares En El 2014,
                  Consolidar Su Presencia En El Mercado De EEUU Y Europa.
                </td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Lucía Cecilia Irurita Siverio{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Actriz Con 60 Años De Trayectoria Artística, Desde El 2002 Es
                  Presidenta De La Asociación Cultural Artes Unidas Y
                  Propietaria Del Teatro De Lucía, El Cual Abrió Sus Puertas Al
                  Público En Abril De 2012 Después De Muchos Años De Lucha
                  Contra Una Serie De Trabas Y Trámites. Lucía Lo Administra
                  Junto Con Sus Hijas También Actrices.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            DIRECTORIO Y RESEÑAS DE GANADORES DEL PREMIO ADULTO MAYOR PRIMA AFP
            2015
          </h1>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor
        </h2>
        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Artistico:
        </h3>
        <h4 className="font-family-secondary c-gray--4 fw-0 tw-f-14 tw-f-14@lg tw-mb-2 tw-mb-3@lg">
          - AREA ARTES MUSICALES, ARTES ESCENICAS Y AUDIOVISUALES:
        </h4>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Jaime Guillermo Guardia Neyra{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  El Maestro Jaime Guardia, Nació En Pausa, Ayacucho; Es Un
                  Destacado Charanguista, Cantante, Compositor E Investigador
                  Musical, Con Una Trayectoria De Seis Décadas Difundiendo La
                  Música Del Departamento De Ayacucho, En El País Y En El
                  Extranjero, Siendo Considerado Por La Crítica Como El Mejor
                  Charanguista Solista Del País. Se Crio Con Su Madre Y Su
                  Abuela, A Su Padre Lo Conoció De Grande Pero No Mantuvo
                  Contacto Con Él, El Mayor De 8 Hermanos Y Vino A Lima En El
                  Año 40, Perdió La Visión De Un Ojo Debido A Una Enfermedad, Y
                  Preocupado Porque Le Dijeron Que No Podía Seguir Estudiando
                  Regresó A Pausa Con Su Abuelita En 1945. En 1946 Empezó Su
                  Actividad Artística Tocando Simultáneamente La Quena, El
                  Charango Y La Guitarra Como Solista En Diversos Actos
                  Culturales En La Escuela. Obtuvo Una Beca Para Seguir Sus
                  Estudios Secundarios, Le Gustó La Música Desde Niño Y Siempre
                  Iba A Escuchar A Los Músicos En Sus Reuniones Y Así Aprendió A
                  Tocar Sus Instrumentos Y A Cantar. Tenía El Oficio De
                  Sombrerero Y Trabajaba En Su Chacra. No Tuvo Maestro De
                  Instrumento, Aprendió Gracias A Un Vecino Ignacelio Huayta
                  Quien Tenía Buen Manejo Del Charango Y Le Daba Indicaciones Y
                  Se Fue Perfeccionando. En 1950 Se Dio A Conocer Como Solista
                  De Canto, Charango Y Guitarra En Lima; Conoció Al Amauta
                  Arguedas Haciéndose Muy Amigos E Integró El Conjunto "La Lira
                  Pausina", Grabando Seis Discos LP. Ha Compuesto Algunas
                  Canciones Para La Lira Pausina Y Para Él Como Solista; En Los
                  60s Alcanzó Mayor Éxito Gracias A Sus Participaciones En
                  Concursos Folclóricos. En 1963 Se Casa Y Se Establece En
                  Barranco; En Los 70s Los Viajes, Conciertos Y Homenajes Se
                  Incrementaron Al Igual Que Sus Viajes Al Extranjero.
                  Desarrolló Una Importante Labor Como Profesor De Música Y
                  Promotor De Jóvenes Talentos. Posee Diversas Condecoraciones
                  Como El Grado De Comendador Otorgado Por El Presidente De La
                  República, Dr. Alejandro Toledo; El Premio Daniel Alomía
                  Robles A. Del Colegio De Arquitectos, Declarado Patrimonio
                  Vivo Por La Municipalidad Provincial De Paúcar Del Sara Sara,
                  Y Muchos Más.
                </td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Venancio Shinki Huamán{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Es Uno De Los Pintores Más Representativos De La Plástica
                  Nacional. Según Wuffarden "Shinki Ha Enriquecido Nuestra
                  Memoria Visual A Lo Largo De Una Trayectoria Ejemplar En El
                  Contexto Del Arte Peruano Contemporáneo. Su Pintura
                  Evoluciona, Sin Saltos Ni Cortes Violentos, Desde La Poética
                  Informalista De Los Comienzos Hasta La Actual Maestría". Según
                  Moll "Sus Obras Plásticas Representan Una Simbiosis Entre Su
                  Ascendencia Oriental, Finamente Rememorizada, Y Su Nacimiento
                  En Supe, Al Lado Del Mar, Habiendo Sido Criado Con El Rigor De
                  Un Trabajador De Campo, Primero Y De Maestro Pintor, Después.
                  Ha Sido Profesor Del Art Center En Miraflores Desde Los Años
                  60 Y Se Ha Labrado Un Futuro En Las Artes Visuales, Que Ya
                  Pertenece A La Historia De La Cultura Nacional ... Testigo De
                  Su Gran Talento E Incansable Valor Emanados De Una Persona Que
                  Ha Sabido Mantenerse Al Margen De Vanos Bombos Y Platillos,
                  Siempre Manteniendo Un Inusitado Perfil Bajo Que Lo Enaltece
                  Como Persona Y Artista ...". Ingresó A La Escuela De Bellas
                  Artes (1954) Luego De Aprobar Un Examen De Dibujo, No Tardó En
                  Demostrar Su Talento, El Premio "Sérvulo Gutiérrez" (1962) Que
                  Le Diera La Escuela Sería El Inicio De Un Sinnúmero De Premios
                  Y Reconocimientos A Lo Largo De Sus 60 Años De Trayectoria
                  Artística. Ya Recuperado De Una Afección Al Corazón Que Le Ha
                  Significado Disminuir El Ritmo De Trabajo, Expuso El Año
                  Pasado En La Galería Lucía De La Puente, Apreciándose Que En
                  Sus Obras Se Mantienen Consolidados Los Elementos Siempre
                  Usados Por Él, Como La Luna, El Sol, El Toro, El Ave, La
                  Montaña, El Árbol, La Roca, La Mujer, La Pareja. En Una
                  Reciente Entrevista Que Concedió A El Comercio Señaló Lo
                  Siguiente: "Soy Un Artista Veterano Que Quiere Morir
                  Pintando".
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Empresarial:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Manuel Antonio Biondi Cosio{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Ingeniero Agrónomo Especialista En Olivicultura Y Elaiotecnia
                  Y En Horticultura, Gerente General De Biondi Y Cía. De Tacna
                  S.A.C. Desde Hace 33 Años, Empresa Que Produce Las Cotizadas
                  Aceitunas Gourmet Biondi, Cultivo Que Iniciara Su Padre En
                  1960 Cuando Adquirió 150 Ha En La Yarada (Tacna) Instalando
                  Uno De Los Primeros Huertos De Olivos Con Tecnología De Última
                  Generación Logrando Así Un Oasis Artificial Regado Con Agua De
                  Subsuelo Que Hoy Alberga Más De 17,000 Árboles De Olivo De
                  Variedades Especiales Y Que -Gracias A Su Creatividad E
                  Innovación, Excelente Dirección, Además Del Exigente Y
                  Cuidadoso Trabajo De Campo Y Bodega- Representa La Más
                  Importante Empresa De La Región Tacna, Debiendo Destacar Que
                  Sus Productos Están Respaldados Por Altos Estándares De
                  Calidad Y Se Exportan Con Éxito A Más De 8 Países De 3
                  Continentes Que Reconocen Su Exquisita Presentación Y Sabores
                  Únicos. Asimismo, Es Importante Mencionar Que El Ing. Biondi
                  Forma Parte De La Siguiente Generación Forjadora Del Famoso
                  Pisco Biondi, Gracias Al Impulso Que Le Dieron Él Y Su Hermano
                  César, Ingeniero De Ciencias Alimentarías, A La Empresa
                  Familiar Que Habían Constituido Con Su Padre Y Su Hermano
                  Oscar Llamada Hoy Antonio Biondi E Hijos S.A.C., Que Posee La
                  Más Moderna Planta De Elaboración De Pisco En Moquegua Que
                  Produce Piscos De La Más Alta Diferenciación Que Son “Top” De
                  Calidad Y Precio En El Muy Competitivo Mercado Peruano.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo de Servicio Social:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Ugo De Censi Scarafoni{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Ugo De Censi, Es Un Destacado Sacerdote Italiano Al Que El
                  Gobierno Peruano Le Otorgó La Nacionalidad Peruana En El 2008,
                  Un Gran Anhelo Que Tenía Dado Su Gran Amor Por El Perú.
                  Pertenece Desde Hace 63 Años A La Congregación Salesiana De
                  Don Bosco, Y Es Fundador De La Operación Mato Grosso En Italia
                  -Movimiento Juvenil De Ayuda A Los Pobres- Además De Propulsor
                  Del Trabajo Educativo-Pastoral Que Realiza Dicha Organización.
                  Su Trayectoria De Vida Es Muy Sacrificada E Intensa, De
                  Entrega A Los Más Necesitados. Ama Trabajar Con Los Jóvenes Y
                  Enseñarles Al Igual Que Lo Hacía Don Bosco. De 1976 Al 2013
                  Fue Párroco De Chacas, Un Pueblo Ubicado En Las Alturas De La
                  Sierra Del Perú, En Huari, Ancash. Mediante La Educación Ha
                  Logrado Un Futuro Mejor Para Cientos De Niños Y Jóvenes Así
                  Como Contribuido A Mejorar La Calidad De Vida De Sus Familias.
                  Muchos De Los Jóvenes Formados En El Colegio-Taller Don Bosco,
                  Hoy Son Parte De La Familia De Artesanos Don Bosco,
                  Principalmente Como Fabricantes De Muebles, En El Caso De Los
                  Hombres Y, De Textiles, En El Caso De Las Mujeres; Sus
                  Productos Son Exportados A Diversas Partes Del Mundo Y Muy
                  Cotizados Por Su Gran Calidad Y Bellos Diseños; Constituyendo
                  Un Modelo De Emprendimiento Exitoso Que Contribuye Al
                  Desarrollo De La Zona, Gracias A A La Generación De Empleo
                  Para Estos Jóvenes Y Así No Emigren De Sus Pueblos. Ha
                  Recibido Importantes Reconocimientos Tanto A Nivel Nacional
                  Como Internacional.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Intelectual - Area Ciencias:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Jorge Arturo Heraud Pérez{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  El Dr. Heraud Es Bachiller En Ingeniería Mecánica Eléctrica,
                  Por La Universidad Nacional De Ingeniería, Master Of Science Y
                  Doctor Of Philosophy Por La Universidad De Stanford, En
                  California, EEUU. Sus Campos De Trabajo Son La Electrónica,
                  Sistemas Digitales, Computación, Inteligencia Artificial,
                  Radiociencia, Física De La Ionósfera, Así Como El Uso De
                  Técnicas De Radio Y Radar Para El Estudio De La Ionósfera,
                  Radio Propagación , Radio Comunicaciones Y Comunicaciones
                  Digitales. El Dr. Jorge Heraud Es, Como Científico, Profesor E
                  Investigador, Un Claro Ejemplo De Lo Que Un Hombre De Ciencia
                  Puede Lograr En El Campo Del Desarrollo Científico Y
                  Tecnológico En El Perú, Cuando Actúa Con Rigor, Seriedad,
                  Espíritu De Superación Y Perseverancia, Y Constituye Un
                  Invalorable Modelo De Conducta Profesional En Esta
                  Indispensable Y Trascendental Área Del Saber, Tanto En Su
                  Dimensión Especulativa Como Aplicada.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Intelectual - Area Humanidades:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Armando Nieto Vélez S.J.{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  El Nombre De Armando Nieto Vélez S.J. Se Inscribe En La
                  Historia De La Historiografía Peruana Como El De Uno De Los
                  Más Destacados Representantes De La Generación De
                  Historiadores Del "Medio Siglo" De Acuerdo Con La
                  Clasificación Propuesta Por César Pacheco Vélez, Es Decir, De
                  Aquel Grupo De Investigadores Que Inauguran Su Actividad
                  Historiográfica En La Década De 1950. Su Vasta Producción En
                  Dicho Campo Exhibe Rigor Científico, Siendo Su Mayor Aporte En
                  Las Áreas De La Historia Eclesiástica Y La Vida De Santos.
                  Hombre De Iglesia, Historiador Y Maestro Universitario, El P.
                  Nieto Es Autor De Una Vasta Y Fecunda Obra –Contenida En
                  Libros, Artículos, Discursos Y Ponencias– Que Versa Sobre
                  Diversos Temas De Nuestra Historia. El Fidelismo Colonial,
                  Acontecimientos Y Figuras De La Emancipación, Episodios Y
                  Personajes De La Guerra Del Pacífico, La Acción Evangelizadora
                  En Los Siglos XVI-XVII, Vidas De Cristianos Ejemplares En El
                  Virreinato Peruano, Son Algunos De Los Tópicos Que Aborda
                  Desde Su Singular Visión De Historiador Y Hombre De Fe. El
                  Estudio De Tal Pluralidad Temática Se Ve Enriquecida En La
                  Obra De Nieto, Además, Por Su Condición De Teólogo, Filósofo Y
                  Jurista. En El 2014 El Ministro De Defensa, Pedro Cateriano,
                  Los Distinguió Con La “Orden Militar De Ayacucho” En Grado De
                  Gran Oficial Por Su Importante Contribución Como Historiador Y
                  Catedrático.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Primer Lugar Campo Emprendedor
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Francisco Contreras Campos{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Médico Oftalmólogo, Gerente General De Oftalmólogos Contreras
                  Soc. Civil De Responsabilidad Limitada, Empresa Que Desde 1987
                  Se Dedica A La Salud Ocular Y Está Conformada Por Un Equipo De
                  Profesionales Especializados En El Cuidado Y Tratamiento De
                  Los Ojos, De Las Diferentes Áreas De La Oftalmología.
                  Oftalmólogos Contreras Contribuye A La Capacitación Y
                  Formación De Los Futuros Médicos Oftalmólogos Y Técnicos
                  Oftálmicos Del País. Ha Publicado Numerosos Artículos En El
                  Campo De La Oftalmología Y En Prevención De Ceguera. Es
                  Fundador Y Presidente De La Asociación Oftalmológica Paracas,
                  Entidad Sin Fines De Lucro Que Realiza Diversas Actividades
                  Educativas Y Campañas Quirúrgico-Asistenciales Tanto En La
                  Periferia De Lima Como En La Provincia De Abancay (Zona Andina
                  Del Perú) Y Otras Zonas Más Deprimidas Del País.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            DIRECTORIO Y RESEÑAS DE GANADORES DEL PREMIO ADULTO MAYOR PRIMA AFP
            2016
          </h1>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor
        </h2>
        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Artistico:
        </h3>
        <h4 className="font-family-secondary c-gray--4 fw-0 tw-f-14 tw-f-14@lg tw-mb-2 tw-mb-3@lg">
          - AREA ARTES MUSICALES, ARTES ESCENICAS Y AUDIOVISUALES:
        </h4>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  José Arturo Torres Ventocilla{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Músico, Compositor, Profesor Y Difusor De La Música Peruana
                  Conocido En El Mundo Artístico Como “Pepe Torres”, Considerado
                  Uno De Los Mejores Concertistas De Guitarra Del Perú, Con Más
                  De 60 Años De Trayectoria Y 600 Conciertos Alrededor Del
                  Mundo, 45 Años Como Profesor De Guitarra Desde Que Fundó Su
                  Academia, Enseñando La Música A Fondo, El Solfeo, La Armonía,
                  Técnica Guitarrística, A Acompañar Con Más De 20 Estilos
                  Musicales, Formación De Acordes, Dando Toda Su Experiencia Y
                  Conocimientos. Ha Enseñado A Más De 10 Mil Alumnos, De Los
                  Cuales 25 Se Consideran Virtuosos Y Vienen Brillando En El
                  Perú Y El Extranjero. 20 Años Dedicados A La Investigación,
                  Leyendo Libros De Música, Habiendo Creado Un Escalafón De
                  Aprendizaje Que Lo Comparte Con Sus Alumnos. Interpreta
                  Diversos Géneros Musicales, Desde Piezas De Johann Sebastián
                  Bach, Bossa Nova De Antonio Carlos Jobim, Valses De Felipe
                  Pinglo Alva, Hasta Mazurcas De Frédéric Chopin. Creó Su
                  Agrupación “Perú Folklórico” Junto Con Esmila Zevallos
                  Realizando Muchos Conciertos Internacionales. Trabajó 29 Años
                  En La TV Peruana, En 14 Programas Y Participó En La Creación
                  De 8 De Ellos, Co-Creador Y Director Musical Del Programa
                  Diario De Música Criolla “Mediodía Criollo”; Productor,
                  Director Musical Y Arreglista De Diversos Programas De
                  Televisión, Festivales Y Destacados Artistas De Música
                  Criolla. Ha Escrito Y Grabado Arreglos Musicales Para Casi
                  Todos Los Artistas Criollos Conocidos, Y Muchos De Los Nuevos
                  Lo Consideran Su Mentor, Su Profesor, Su Padrino. Tiene 25
                  Discos Grabados Como Solista Y También Discos Con Cantantes De
                  Renombre Como Jesús Vásquez, Luis Abanto Morales, Tania
                  Libertad, Eva Ayllón, Cecilia Bracamonte, Edith Barr, Los
                  Quipus, Los Hermanos Zañartu, Los Embajadores Criollos, Los
                  Morochucos, Etc. Tiene Un Estudio De Grabación Con EquiposA1,
                  Perfecto Para Un Conocedor De Equipos De Sonido Y Música
                  Selecta.
                </td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Feliciano Salazar Liza{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Destacado Maestro Artesano, Joyero Independiente, Ha Formado
                  Su Propio Taller Donde Ha Desarrollado La Técnica De
                  Filigrana, Joyería, Orfebrería En Oro Y En Plata. Aprendió
                  Este Arte De Sus Antepasados, Desde Muy Pequeño Ayudaba En El
                  Taller De Su Casa En El Distrito De Monsefú. El Diseño De La
                  Joya Lo Hace Al Gusto Del Cliente, Pero El Tamaño Definitivo
                  Del Ornamento Lo Da El Maestro, De Las Feligresías Y
                  Hermandades Vienen Los Encargos Más Difíciles Y Caros. Ha
                  Realizado Las Réplicas De Las Joyas Del Señor De Sipán, Que Se
                  Exhiben En Museos Como En Alemania Y España Y Que Son
                  Mundialmente Conocidas. Ha Enseñado A Generaciones De Jóvenes
                  Durante Algo Más De 60 Años, Por Su Taller Han Pasado Más De
                  500 Alumnos, De Los Cuales Unos Pocos Lo Han Superado, El
                  Maestro Siempre Incentiva A Sus Alumnos Con Su Lema “Si Me
                  Ganas Eres Bueno”, Actualmente Algunos De Ellos Se Encuentran
                  Trabajando Tanto En El País Como En El Extranjero. Ha
                  Confeccionado Diversas Joyas, Réplicas, Arcos De Plata Para El
                  Señor De Los Milagros, Coronas Para Vírgenes Veneradas En
                  Muchas Iglesias Del País, Ha Participado En Diferentes Ferias
                  Y Exposiciones Y Es Reconocido Y Galardonado Por Diferentes
                  Instituciones Como El Patronato De La Plata Del Perú. Ha Sido
                  Distinguido Con El Premio Joaquín López Antay, Entre Otros.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Empresarial:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Juan Vidaurrazaga Zimmermann{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Destacado Empresario Arequipeño, Miembro De La Segunda
                  Generación Vidaurrazaga, Que Por Más De 50 Años Ha Contribuido
                  Con Sus Cualidades Personales Y Profesionales Al Desarrollo Y
                  Engrandecimiento De Una De Las Empresas Familiares Más
                  Emblemáticas De Arequipa, La Fábrica De Chocolates La Ibérica
                  S.A., Que Da Empleo A 400 Personas. Su Capacidad De Liderazgo
                  Y Emprendimiento Han Hecho Que La Ibérica, Con 107 Años En El
                  Mercado, Continúe Elaborando Sus Productos Con La Más Alta
                  Calidad, Pasando De Una Pequeña Fábrica En El Centro De La
                  Ciudad A La Que Actualmente Ocupa En El Principal Parque
                  Industrial De Arequipa, Reconocida A Nivel Local, Nacional E
                  Internacional. Asimismo, Se Ha Preocupado Por Preparar A La
                  Tercera Generación Para Que Tome La Posta En Su Momento Y Así
                  Asegurar La Continuidad De La Empresa, Adecuándose A Los
                  Nuevos Conocimientos Y Tecnologías Sin Perder Su Originalidad.
                  Luego De Haber Logrado Consolidarse En El Mercado Nacional
                  Están Preparando Su Ingreso En El Mercado De América Latina,
                  Empezando Por Chile.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo de Servicio Social:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Carmen María Antonia Masías Claux{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Destacada Psicóloga En Terapia Familiar Con Estudios De
                  Doctorado En Psicología. Directora Fundadora Del Centro De
                  Información Y Educación Para La Prevención Del Abuso De Drogas
                  - CEDRO Hace 30 Años Junto Con Un Grupo De Peruanos,
                  Provenientes De Todos Los Sectores De La Sociedad Peruana
                  Preocupado Por El Creciente Consumo De Drogas En El Perú Y La
                  Amenaza Del Narcotráfico, Y Que Deseaba Conformar Una
                  Institución Que Pudiera Enfrentar Esta Problemática Desde Una
                  Perspectiva Integral, Considerando Las Diversas Dimensiones
                  Que Implicaba. Enseñó En La UPCH Y En La UNFV, A Nivel De
                  Maestría; Pertenece Al Comité Consultivo De La USIL Fue
                  Presidenta Ejecutiva De DEVIDA (2012-2014), Ente Rector De
                  Políticas De Drogas, Logrando Una Reducción Del 17.5% Del
                  Espacio Cocalero, Lo Que Fue Un Hito Histórico. Su Logro Más
                  Importante Fue Recibir De La UNICEF El Premio World Of
                  Children Award 2007, Categoría Humanitaria, Mostrando Un Gran
                  Gesto De Desprendimiento Al Donar A CEDRO Los 50 Mil Dólares
                  Que Recibió. Es Consultora, Expositora Y Escribe Artículos
                  Para Diversos Medios, Sobre Educación Para La Prevención Del
                  Abuso De Drogas.
                </td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Víctor Domingo Zambrano Gonzalez{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Activista Ambiental Madrediosense, Ha Logrado Influir En La
                  Población Amazónica Un Cambio De Actitudes Para El Cuidado Del
                  Medio Ambiente, Hábitos Que Les Permitan Manejar Adecuadamente
                  Los Recursos Naturales Existentes En Su Ámbito, Impulsando
                  Actividades Sostenibles Con El Fin De Disminuir El Impacto De
                  La Deforestación Causante Del Cambio Climático Aplicando
                  Tecnologías Acordes Con El Medioambiente Donde Se Desarrollan
                  Mediante La Recuperación De Áreas Degradadas A Través De
                  Sistemas Agroforestales, Ha Creado Organizaciones Agrarias Con
                  Más De 5,000 Familias Teniendo Como Escuela Su Propio Fundo
                  Que De Potrero Lo Convirtió En Un Bosque. Fundador De
                  Organizaciones Como La Coordinadora Agroforestal Indígena Y
                  Campesina Del Perú. Los Niños Y Jóvenes Lo Ven Como Un Ejemplo
                  A Seguir. Ha Recibido Muchos Reconocimientos Locales,
                  Nacionales E Internacionales, Siendo Reconocido Y Galardonado
                  Como Héroe Ambiental Y Liderazgo En Conservación En La
                  Actualidad Es Presidente Del Comité De Gestión De La Reserva
                  Nacional Tambopata Y Vicepresidente Del Consejo De
                  Coordinación De Los Comités De Gestión De Las 74 Áreas Rurales
                  Protegidas Del Perú.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Intelectual - Area Ciencias:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  José Eduardo Gotuzzo Herencia{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Es El Experto Más Reconocido De América Latina En Enfermedades
                  Infecciosas Y Medicina Tropical Según Los Investigadores Y
                  Clínicos De Enfermedades Infecciosas En El Mundo. Su Trabajo
                  Inicial Con La Fiebre Tifoidea Lo Colocó Como Una Autoridad
                  Mundial En El Diagnóstico, Tratamiento Y Prevención En
                  Tifoidea. Al Inicio De 1990, Cuando La Pandemia Del Cólera
                  Reapareció En El Perú Después De Un Siglo De Ausencia En
                  América Latina, El Dr. Gotuzzo Tuvo Una Destacada
                  Participación En La Respuesta Rápida, Siendo Reconocido Como
                  Un Experto Internacional En Los Aspectos Clínicos Y
                  Tratamiento Del Cólera. Durante Los Últimos Años, Se Ha
                  Involucrado En La Investigación De Las Enfermedades Emergentes
                  Y Re-Emergentes En América Latina: HTLV-I, Amebas De Vida
                  Libre Y TBC MDR. Por Muchos Años Fue Director Del Renombrado
                  Curso Gorgas De Medicina Tropical, Que Entrena A Especialistas
                  De Enfermedades Infecciosas Alrededor Del Mundo. Tiene Cerca
                  De 300 Artículos Y Más De 40 Capítulos De Libros, Habiendo
                  Contribuido Prodigiosamente A La Literatura De Enfermedades
                  Infecciosas En Una Amplia Gama De Tópicos. Su Dedicación A La
                  Especialidad Es También Obvia En Su Historial De Servicio. Es
                  De Mención Notable, Indicar Que Él Sirve Como Miembro Del
                  Prestigioso Foro De Amenaza Microbiana Del Instituto De
                  Medicina De La Academia De Estados Unidos.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Intelectual - Area Humanidades:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Enrique Bernales Ballesteros{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Graduado En La Universidad De Grenoble Francia, Como Doctor En
                  Derecho 1968; Decano De La Facultad De Ciencias Sociales De La
                  PUCP; Asesor De La Comisión Principal De La Asamblea
                  Constituyente De La Constitución De 1979; Publica Junto Con El
                  Dr. Marcial Rubio El Primer Estudio Completo De La
                  Constitución De 1993; Senador De La República Elegido En Tres
                  Períodos Continuos Con Alta Votación. Fue Presidente Y Relator
                  Especial De La Comisión De Derechos Humanos De La ONU.
                  Director Académico, Ejecutivo De La Comisión Andina De
                  Juristas; Miembro De La Comisión De La Verdad Y En El 2003
                  Suscribe El Informe Final De La Comisión. Fue Miembro Del
                  Grupo De Trabajo Del Lugar De La Memoria. Ha Sido Miembro Del
                  Directorio De EMILIMA S.A. En El Trabajo De Recuperación Del
                  Centro Histórico De Lima. Ha Publicado Más De 30 Obras En
                  Temas De Análisis Político, Sociología Política, Problemática
                  Universitaria Y Derecho Constitucional. En La Actualidad Es
                  Miembro De La Asociación Civil Transparencia, Presidente Y
                  Fundador De La Asociación Cultural De Artes Musicales
                  "Romanza" Y Miembro De La ONG "Proética" Donde Realiza Una
                  Importante Acción Cultural, Y Editorialista Del Diario El
                  Comercio. Ha Sido Reconocido A Nivel Nacional Con La Orden Al
                  Mérito De La MML, La Orden Al Mérito Civil, La Orden Al Mérito
                  Isabel La Católica Otorgado Por El Gobierno De España, Entre
                  Otros.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Primer Lugar Campo Emprendedor
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Adolfo Figueroa Otazu </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Es Un Agricultor De Maranura, La Convención, Que Comercializa
                  Sus Propios Productos Desde Los 25 Años. Como En La Zona La
                  Agricultura No Es Tan Rentable Para Poder Crecer
                  Económicamente, Decidió Con Su Familia Darle Una Alternativa A
                  La Agricultura Y Formar En El 2011 Su Empresa El Mangal SRL En
                  El Rubro Turístico (Albergue Y Agroturismo). Cuenta Con Un
                  Fundo Cuyo Microclima Favorece La Diversificación De Plantas Y
                  Donde Conserva Variedades De Árboles Centenarios Como El
                  Cacao, Mango Y Coca. Son Coleccionistas De Más De 250 Plantas
                  Tanto De La Región, Como De Origen Nacional Y Foráneo. Su
                  Potencial: Sus Productos Orgánicos Y La Cercanía A La Ruta
                  Turística A Machu Picchu. Le Apasiona Mucho La Agricultura Y
                  Quiere Que Sus Hijos Sigan Conservando El Fundo Y Las Plantas.
                  El Albergue Se Ubica En El Fundo Cocabambilla (15 Ha) Y Brinda
                  A Sus Huéspedes Los Servicios De Alojamiento, Alimentación,
                  Piscina, Área De Camping Y Comodidades Para Preparar Sus
                  Propias Comidas Y La Posibilidad De Degustar Los Frutos Del
                  Lugar. En La Línea Agroturismo Ofrecen Tours Demostrativos Y
                  Participativos: "Aroma Del Cacao Orgánico", "Aroma De Café
                  Orgánico", "Aroma De Coca Medicinal Y Terapéutico". Producen
                  Cacao Orgánico Y Café Orgánico Con La Marca ADOROS.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
  {
    content: (
      <>
        <div className="tw-mb-6 tw-mb-6@lg left">
          <h1 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
            DIRECTORIO Y RESEÑAS DE GANADORES DEL PREMIO ADULTO MAYOR PRIMA AFP
            2017
          </h1>
        </div>

        <h2 className="font-family-secondary c-gray--4 fw-0 tw-f-18 tw-f-18@lg tw-mb-2 tw-mb-3@lg">
          Premio Reconocimiento al Adulto Mayor
        </h2>
        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Artistico:
        </h3>
        <h4 className="font-family-secondary c-gray--4 fw-0 tw-f-14 tw-f-14@lg tw-mb-2 tw-mb-3@lg">
          - AREA ARTES MUSICALES, ARTES ESCENICAS Y AUDIOVISUALES:
        </h4>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Carlos Ernesto Gassols Eizaguirre{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Primer Actor Del País Que Destacó Desde Muy Tierna Edad Y Hoy
                  Tiene Toda Una Vida Dedicada Al Teatro. Es Además Director Y
                  Dramaturgo. Publicó Su Libro “Mi Vida En El Teatro” En El 2015
                  Y Ha Tenido Una Dedicada Y Destacada Labor Docente Formando
                  Varias Generaciones De Actores En El Perú. En El 2001 Creó Y
                  Produjo Para Radio Nacional Del Perú El Programa “El Invitado
                  Del Aire” En El Que Entrevista A Personajes Destacados, El
                  Cual Continúa Conduciendo Y Cuenta Con Una Gran Audiencia. Fue
                  Presidente Y Secretario General Del Sindicato De Actores Del
                  Perú (1969-71) Y Director Del Teatro Nacional Popular
                  (1979-83). En 1956 Fue Cofundador Del Importante Grupo
                  Histrión, Contribuyendo A La Renovación Del Teatro Peruano.
                  Hasta El Día De Hoy Continúa Actuando En Telenovelas Y
                  Películas De Éxito. Sus Más De 80 Años De Fecunda Labor Lo Han
                  Hecho Merecedor De Premios Y Distinciones Del Sindicato De
                  Actores Del Perú, Del INC, De La UNMSM, La Medalla Al Mérito
                  Ciudadano De La PCM En El 2016, Y Homenajes Como El Que
                  Recibió En El Festival De Cine De Lima 2009, Entre Otros.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h4 className="font-family-secondary c-gray--4 fw-0 tw-f-14 tw-f-14@lg tw-mb-2 tw-mb-3@lg">
          - AREA ARTES PLASTICAS Y ARTES GRAFICAS
        </h4>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Félix Espinoza Vargas </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Talentoso Artista Plástico Que, Superando La Adversidad, Ha
                  Logrado Desarrollar Una Destacada Trayectoria Artística Como
                  Pintor, Grabador, Tallador En Madera, Acuarelista Y Ceramista.
                  Estudió Pintura En La Escuela De Artes Plásticas De La PUCP;
                  Realizó Otros Estudios En Inglaterra, Cuba, EEUU, México,
                  España Y En El Perú En Las Técnicas De Pintura, Litografía,
                  Cerámica, Acuarela, Talla En Madera Y Escultura. Enseñó Arte
                  En Diversas Universidades E Instituciones Educativas De Lima.
                  Fue Miembro Hasta El 2015 De La Asociación Internacional De
                  Pintores Que Pintan Con La Boca Y El Pie, Que Tiene Su Sede En
                  Suiza. Ha Difundido Sus Trabajos A Nivel Nacional E
                  Internacional. Tiene 190 Exposiciones Colectivas E
                  Individuales Realizadas En Varias Ciudades Del Perú Y En El
                  Extranjero (Suiza, Austria, España, Rumania, Serbia, Taiwán,
                  EE.UU., México, Brasil, Argentina, Entre Otros.) Habiendo
                  Recibido Muchos Premios Y Reconocimientos.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Empresarial:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">Rafael Quevedo Flores </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Ing. Agrónomo Director Del Grupo Rocío, Corporación Líder En
                  El Norte Del País Con Unidades De Negocio En Los Sectores
                  Avícola, Agrícola Y Ganadero. Distribuye Productos A Nivel
                  Local, Nacional E Internacional, Exportando Con La Mejor
                  Calidad Espárragos Frescos Y Enlatados A España Y Alemania, Y
                  Palta Hass A EE.UU. Y Marruecos, También A Mercados Como
                  Singapur Y Hong Kong. Viene Desarrollando 1200 Ha De
                  Arándanos, Que Se Suman A Las Casi 600 Ha De Espárragos Y 800
                  Ha De Palta. En Ganadería Tiene 5000 Cabezas De Ganado Vacuno
                  Que Producen 100,000 Ml De Leche/Día. Tiene Muchos
                  Reconocimientos De Instituciones Y Gremios Empresariales
                  Además De Haber Ocupado Cargos Importantes En El País Como El
                  De Ministro De Agricultura En El 2010, Entre Otros.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo de Servicio Social:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Juana Rosa Martin Roncal{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Hermana De La Congregación Religiosa San José De Tarbes, A La
                  Cual Ingresó A Los 16 Años. Como Religiosa Estudió En Varios
                  Lugares, Pudiendo Luego Desempeñarse Como Profesora De
                  Primaria En Colegios De Piura. Creó Comedores Populares Para
                  Niños Y Adultos Mayores Y Hasta El Día De Hoy Los Dirige,
                  Además De Ser Guía Espiritual De Las Personas Que Llegaban A
                  Pedir Consejo. Gracias A Su Apoyo Se Ha Construido Un Centro
                  Comunal Integral Micaela Bastidas, La Casa Del Adulto Mayor
                  San Sebastián, El Comedor Del Adulto Mayor Mi Cautivo, El
                  Comedor Infantil Granito De Arena. Esta Travesía De Dirigir
                  Comedores Se Inició En 1983, Año En Que Piura Fue Azotada
                  Duramente Por El Fenómeno El Niño. En Los 76 Años Que Tiene En
                  La Congregación Se Ha Ganado El Aprecio Y Respeto No Solo De
                  Sus Hermanas Religiosas Sino De Toda La Gente Que Conoce Su
                  Abnegada Labor.
                </td>
              </tr>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Víctor Domingo Zambrano Gonzalez{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Activista Ambiental Madrediosense, Ha Logrado Influir En La
                  Población Amazónica Un Cambio De Actitudes Para El Cuidado Del
                  Medio Ambiente, Hábitos Que Les Permitan Manejar Adecuadamente
                  Los Recursos Naturales Existentes En Su Ámbito, Impulsando
                  Actividades Sostenibles Con El Fin De Disminuir El Impacto De
                  La Deforestación Causante Del Cambio Climático Aplicando
                  Tecnologías Acordes Con El Medioambiente Donde Se Desarrollan
                  Mediante La Recuperación De Áreas Degradadas A Través De
                  Sistemas Agroforestales, Ha Creado Organizaciones Agrarias Con
                  Más De 5,000 Familias Teniendo Como Escuela Su Propio Fundo
                  Que De Potrero Lo Convirtió En Un Bosque. Fundador De
                  Organizaciones Como La Coordinadora Agroforestal Indígena Y
                  Campesina Del Perú. Los Niños Y Jóvenes Lo Ven Como Un Ejemplo
                  A Seguir. Ha Recibido Muchos Reconocimientos Locales,
                  Nacionales E Internacionales, Siendo Reconocido Y Galardonado
                  Como Héroe Ambiental Y Liderazgo En Conservación En La
                  Actualidad Es Presidente Del Comité De Gestión De La Reserva
                  Nacional Tambopata Y Vicepresidente Del Consejo De
                  Coordinación De Los Comités De Gestión De Las 74 Áreas Rurales
                  Protegidas Del Perú.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Intelectual - Area Ciencias:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Ladis Italia Delpino Artadi Viuda De Soto{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Médico Especialista En Radiología, Doctora En Medicina, Con
                  Una Especialización En Mamografía En EEUU Y En Radiología Del
                  Temporal (Oído) En Argentina. Primera Mujer Radióloga En El
                  País, Quién Introdujo Por Primera Vez La Mamografía En El
                  País. Primera Mujer Que Alcanzó La Jefatura De Un Departamento
                  En El Hospital Loayza, Donde Laboró Durante 38 Años.
                  Presidenta En Dos Oportunidades De La Sociedad Peruana De
                  Radiología, Integrante Del Comité De Distinciones Honorificas
                  Del CMP. Investigadora Radiológica De Los Restos De Francisco
                  Pizarro, Contribuyendo A La Arqueología Del País; Miembro
                  Fundador De La Sociedad Peruana De Mastología; Miembro
                  Fundador De La UPCH, Llegando A Ser Profesora Emérita Y
                  Condecorada Con La Orden Cayetano Heredia En El Grado De
                  Comendador. Fundadora Y Organizadora Del Voluntariado En El
                  Hospital Loayza, Trabajó Ad Honorem Varios Años En El
                  Policlínico San Camilo.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-family-secondary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-2 tw-mb-3@lg">
          Campo Intelectual - Area Humanidades:
        </h3>
        <div className="table-0 w-100 tw-mb-6 tw-mb-8@lg">
          <table className="w-100">
            <thead className="bg-orange-0">
              <tr>
                <th className="w-45 tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Nombre</span>
                </th>
                <th className="w-55 tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-4@lg center">
                  <span className="c-white tw-f-16 tw-f-18@lg">Reseña</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-py-5 b tw-pl-9@lg">
                  Rodolfo Marcial Cerrón Palomino{' '}
                </td>
                <td className="tw-py-5 tw-pr-9@lg">
                  Doctor En Lingüística De La UNMSM Dedicado A Las Lenguas
                  Andinas, En Especial Las Quechuas, El Aimara, El Mochica, Y El
                  Chipaya, Interés Que Nació Al Crecer En Un Ambiente
                  Castellano-Quechua. Obtuvo El Grado De Maestría En La
                  Universidad Cornell Y El Grado De PhD En La Universidad De
                  Illinois. Su Obra Comprende 22 Libros Completos; 16 Capítulos
                  De Libros; 65 Artículos En Revistas, Muchas De Ellas
                  Especializadas. Tiene 49 Años De Labor Docente, Brindando
                  Además Conferencias En El País Y El Extranjero. Formó Parte De
                  Comisiones De La Implementación De La Oficialización Del
                  Quechua. Escribió Los Libros: “Diccionario Quechua: Junín
                  Huanca” Y “Gramática Quechua: Junín Huanca”. Ha Recibido
                  Diversas Distinciones, Es El Único Lingüista Peruano Que Ha
                  Sido Nombrado Miembro Honorario De La Linguistic Society Of
                  America, Es Profesor Emérito De La UNMSM, “Personalidad
                  Meritoria De La Cultura” Por El Del Ministerio De Cultura,
                  Entre Otros.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    ),
  },
]
